import React, { useState, useEffect } from "react";
import classes from "./BackToTop.module.css";
import { FaArrowUp } from "react-icons/fa";
import { smoothScrollToTop } from "../../lib/scrollToTop";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    smoothScrollToTop(0.55);
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className={classes.backToTop}
      title="Scroll to top"
    >
      <FaArrowUp />
    </button>
  );
}
